var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase2Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.69961V2.99961C7.5 2.76091 7.59482 2.532 7.7636 2.36321C7.93239 2.19443 8.1613 2.09961 8.4 2.09961H15.6C15.8387 2.09961 16.0676 2.19443 16.2364 2.36321C16.4052 2.532 16.5 2.76091 16.5 2.99961V5.69961H20.1C20.3387 5.69961 20.5676 5.79443 20.7364 5.96321C20.9052 6.132 21 6.36091 21 6.59961V19.1996C21 19.4383 20.9052 19.6672 20.7364 19.836C20.5676 20.0048 20.3387 20.0996 20.1 20.0996H3.9C3.66131 20.0996 3.43239 20.0048 3.2636 19.836C3.09482 19.6672 3 19.4383 3 19.1996V6.59961C3 6.36091 3.09482 6.132 3.2636 5.96321C3.43239 5.79443 3.66131 5.69961 3.9 5.69961H7.5ZM19.2 12.8996H4.8V18.2996H19.2V12.8996ZM19.2 7.49961H4.8V11.0996H7.5V9.29961H9.3V11.0996H14.7V9.29961H16.5V11.0996H19.2V7.49961ZM9.3 3.89961V5.69961H14.7V3.89961H9.3Z",
    fill: "#2D9F75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase2Line);
export default __webpack_public_path__ + "static/media/briefcase-2-line.d06cd7dda1d92d74bde888573742b761.svg";
export { ForwardRef as ReactComponent };